import { render, staticRenderFns } from "./EditPartnerModal.vue?vue&type=template&id=24116a70&scoped=true&class=fill-height&"
import script from "./EditPartnerModal.vue?vue&type=script&lang=ts&"
export * from "./EditPartnerModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditPartnerModal.vue?vue&type=style&index=0&id=24116a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24116a70",
  null
  
)

export default component.exports